import React from 'react';
import { InsuranceType } from '../../api/useInsuranceQuery';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { InstitutionNameInput } from '../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/components/InstitutionNameInput/InstitutionNameInput';
import { AccountOwnerSelect } from '../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountDescription } from '../components/AccountDescription/AccountDescription';
import { IsBrokerOfRecord } from '../components/IsBrokerOfRecord/IsBrokerOfRecord';
import { CoverageType } from '../components/CoverageType/CoverageType';
import { Premium } from '../components/Premium/Premium';
import { TimePeriod } from '../components/TimePeriod/TimePeriod';
import { LongTermCareDailyBenefitAmount } from '../components/LongTermCareDailyBenefitAmount/LongTermCareDailyBenefitAmount';
import { LongTermCareHomeCareCoveragePercentage } from '../components/LongTermCareHomeCareCoveragePercentage/LongTermCareHomeCareCoveragePercentage';
import { LongTermCareNursingCareCoveragePercentage } from '../components/LongTermCareNursingCareCoveragePercentage/LongTermCareNursingCareCoveragePercentage';
import { PremiumEndYear } from '../components/PremiumEndYear/PremiumEndYear';
import { TabsContent } from '../components/TabsContent/TabsContent';
import { InsuranceData } from '../../useInsurance';
import { FormProps } from '../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { ManagementStyles } from '../components/ManagementStyles/ManagementStyles';
import { AssetBucketing } from '../components/AssetBucketing/AssetBucketing';

interface TabProps {
  data: InsuranceData;
}

export const Summary = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <InstitutionNameInput isInsurance />

      <AccountOwnerSelect data={data} insuranceType={InsuranceType.LongTermCare} />

      <AccountDescription />

      <LongTermCareDailyBenefitAmount />

      <ManagementStyles data={data} />

      <AssetBucketing data={data} />

      <IsBrokerOfRecord />
    </Box>
  );
};

export const PolicyDetails = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <CoverageType data={data} />

      <Premium />

      <PremiumEndYear data={data} />

      <Box
        display="grid"
        css={`
          grid-template-columns: 1fr 1fr;
          gap: 24px;
        `}
      >
        <LongTermCareHomeCareCoveragePercentage />

        <LongTermCareNursingCareCoveragePercentage />
      </Box>

      <TimePeriod
        label="Coverage Period"
        fieldName="LongTermCareCoveragePeriod"
        options={data.Options.LongTermCareCoveragePeriodTypeOptions}
      />

      <TimePeriod
        label="Elimination Period"
        fieldName="LongTermCareEliminationPeriod"
        options={data.Options.LongTermCareEliminationPeriodTypeOptions}
      />
    </Box>
  );
};

const tabs = [
  {
    name: 'Summary',
    Component: Summary,
  },
  {
    name: 'Policy Details',
    Component: PolicyDetails,
  },
];

export const LongTermCareForm = (props: FormProps) => {
  return <TabsContent tabs={tabs} {...props} />;
};
